import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import Breadcrumb from '../../components/ui/Breadcrumb';
import MobileNavigation from '../../components/ui/MobileNavigation';
import MetricsCard from './components/MetricsCard';
import ProductGrid from './components/ProductGrid';
import EmployeeTable from './components/EmployeeTable';
import BillingHistory from './components/BillingHistory';
import QuickActions from './components/QuickActions';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { useSelector,useDispatch } from 'react-redux';
import UseProductHook from 'hooks/UseProductHook';
import { get } from 'react-hook-form';
import UseEmployeeHook from 'hooks/UseEmployeeHook';
import UseSale from 'hooks/UseSale';

const VendorDashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('billing');

  const {product} = useSelector((state) => state.product)
  const {employee} = useSelector((state) => state.employee)
  const {getAllProduct} = UseProductHook()
  const {getAllEmployee} = UseEmployeeHook()
  const {getAllSale,getAllExpenseByVendor,getAllCustomerByVendor} = UseSale()
  const {sale,totalSale} = useSelector((state) => state.sale)
  // console.log(employee)
useEffect(() => {
  getAllProduct()
  getAllEmployee()
  getAllSale()
  getAllCustomerByVendor()
  getAllExpenseByVendor()
},[])
  // Mock data
  const mockProducts = [
    {
      id: 1,
      name: "Premium Coffee Beans",
      category: "Beverages",
      price: 24.99,
      inventory: 150,
      totalSales: 89,
      status: "active"
    },
    {
      id: 2,
      name: "Organic Tea Collection",
      category: "Beverages", 
      price: 18.50,
      inventory: 25,
      totalSales: 45,
      status: "active"
    },
    {
      id: 3,
      name: "Artisan Pastries",
      category: "Food",
      price: 12.75,
      inventory: 0,
      totalSales: 156,
      status: "inactive"
    },
    {
      id: 4,
      name: "Fresh Sandwiches",
      category: "Food",
      price: 8.99,
      inventory: 75,
      totalSales: 234,
      status: "active"
    },
    {
      id: 5,
      name: "Energy Drinks",
      category: "Beverages",
      price: 3.50,
      inventory: 200,
      totalSales: 567,
      status: "active"
    },
    {
      id: 6,
      name: "Healthy Snacks",
      category: "Snacks",
      price: 5.25,
      inventory: 10,
      totalSales: 123,
      status: "active"
    }
  ];

  const mockEmployees = [
    {
      id: 1,
      name: "Sarah Johnson",
      email: "sarah.johnson@company.com",
      role: "manager",
      status: "active",
      billingLimit: 500.00,
      totalBilled: 245.50,
      joinDate: "2024-01-15"
    },
    {
      id: 2,
      name: "Mike Chen",
      email: "mike.chen@company.com",
      role: "staff",
      status: "active",
      billingLimit: 300.00,
      totalBilled: 189.25,
      joinDate: "2024-02-20"
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      email: "emily.rodriguez@company.com",
      role: "staff",
      status: "inactive",
      billingLimit: 250.00,
      totalBilled: 67.80,
      joinDate: "2024-03-10"
    },
    {
      id: 4,
      name: "David Kim",
      email: "david.kim@company.com",
      role: "intern",
      status: "pending",
      billingLimit: 100.00,
      totalBilled: 0.00,
      joinDate: "2024-07-25"
    },
    {
      id: 5,
      name: "Lisa Thompson",
      email: "lisa.thompson@company.com",
      role: "manager",
      status: "active",
      billingLimit: 600.00,
      totalBilled: 423.15,
      joinDate: "2023-11-08"
    }
  ];

  const mockTransactions = [
    {
      id: 1,
      transactionId: "TXN-2024-001",
      employeeName: "Sarah Johnson",
      productName: "Premium Coffee Beans",
      amount: 24.99,
      quantity: 1,
      date: "2024-07-30T10:30:00Z",
      status: "completed"
    },
    {
      id: 2,
      transactionId: "TXN-2024-002",
      employeeName: "Mike Chen",
      productName: "Fresh Sandwiches",
      amount: 17.98,
      quantity: 2,
      date: "2024-07-30T12:15:00Z",
      status: "completed"
    },
    {
      id: 3,
      transactionId: "TXN-2024-003",
      employeeName: "Lisa Thompson",
      productName: "Organic Tea Collection",
      amount: 37.00,
      quantity: 2,
      date: "2024-07-29T14:20:00Z",
      status: "pending"
    },
    {
      id: 4,
      transactionId: "TXN-2024-004",
      employeeName: "Emily Rodriguez",
      productName: "Energy Drinks",
      amount: 10.50,
      quantity: 3,
      date: "2024-07-29T09:45:00Z",
      status: "failed"
    },
    {
      id: 5,
      transactionId: "TXN-2024-005",
      employeeName: "Sarah Johnson",
      productName: "Healthy Snacks",
      amount: 15.75,
      quantity: 3,
      date: "2024-07-28T16:30:00Z",
      status: "completed"
    },
    {
      id: 6,
      transactionId: "TXN-2024-006",
      employeeName: "Mike Chen",
      productName: "Artisan Pastries",
      amount: 25.50,
      quantity: 2,
      date: "2024-07-28T11:10:00Z",
      status: "refunded"
    }
  ];

  useEffect(() => {
    const userData = localStorage.getItem('user');
    const token = sessionStorage.getItem('token');
    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
     
      
      // Redirect if not vendor
      
    } else {
      navigate('/whats-app-authentication');
    }
  }, [navigate]);

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleMobileNavToggle = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  const handleEditProduct = (productId, updatedData) => {
    // console.log('Edit product:', productId, updatedData);
    // Mock implementation - in real app, this would update the product
  };

  const handleDeleteProduct = (productId) => {
    // console.log('Delete product:', productId);
    // Mock implementation - in real app, this would delete the product
  };

  const handleEditEmployee = (employeeId, updatedData) => {
    // console.log('Edit employee:', employeeId, updatedData);
    // Mock implementation - in real app, this would update the employee
  };

  const handleDeleteEmployee = (employeeId) => {
    // console.log('Delete employee:', employeeId);
    // Mock implementation - in real app, this would delete the employee
  };
  // console.log(sale)

  const getMetrics = () => {
    const totalProducts = product?.length;
    const activeEmployees = employee.filter(emp => emp?.active === true).length;
    const monthlySales = sale.reduce((sum, t) => sum + t.amount, 0);
    const pendingOrders = mockTransactions.filter(t => t.status === 'pending').length;

    return {
      totalProducts,
      activeEmployees,
      monthlySales,
      pendingOrders
    };
  };

  const metrics = getMetrics();

  const tabs = [
    { id: 'billing', label: 'Billing', icon: 'Receipt' },
    { id: 'overview', label: 'Overview', icon: 'LayoutDashboard' },
    { id: 'products', label: 'Products', icon: 'Package' },
    // { id: 'employees', label: 'Employees', icon: 'Users' },
  ];

  if (!user) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Icon name="Loader2" size={32} className="animate-spin mx-auto mb-4 text-primary" />
          <p className="text-muted-foreground">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header 
        user={user}
        onSidebarToggle={handleMobileNavToggle}
        sidebarCollapsed={sidebarCollapsed}
      />
      
      <Sidebar 
        user={user}
        collapsed={sidebarCollapsed}
        onToggle={handleSidebarToggle}
      />
      
      <MobileNavigation 
        user={user}
        isOpen={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
      />

      <main className={`pt-16 transition-all duration-200 ${
        sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-60'
      }`}>
        <div className="p-6">
          <Breadcrumb user={user} />
          
          {/* Page Header */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
            <div>
              <h1 className="text-2xl font-bold text-foreground mb-2">Vendor Dashboard</h1>
              <p className="text-muted-foreground">
                Welcome back, {user.name}! Here's what's happening with your business today.
              </p>
            </div>
            <div className="flex items-center space-x-3 mt-4 sm:mt-0">
              <Button
                variant="outline"
                iconName="RefreshCw"
                iconPosition="left"
                iconSize={16}
                onClick={() => window.location.reload()}
              >
                Refresh
              </Button>
              <Button
                variant="default"
                iconName="Plus"
                iconPosition="left"
                iconSize={16}
                onClick={() => navigate('/product-management')}
              >
                Add Product
              </Button>
            </div>
          </div>

          {/* Metrics Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <MetricsCard
              title="Total Products"
              value={metrics.totalProducts}
              change="+2 this week"
              changeType="positive"
              icon="Package"
              color="primary"
            />
            <MetricsCard
              title="Active Employees"
              value={metrics.activeEmployees}
              change="+1 this month"
              changeType="positive"
              icon="Users"
              color="success"
            />
            <MetricsCard
              title="Monthly Sales"
              value={`$${metrics.monthlySales?.toFixed(2)}`}
              change="+12.5%"
              changeType="positive"
              icon="DollarSign"
              color="warning"
            />
            <MetricsCard
              title="Total Sales"
              value={totalSale}
              change="-2 from yesterday"
              changeType="negative"
              icon="LeafyGreen"
              color="error"
            />
          </div>

          {/* Tab Navigation */}
          <div className="mb-6">
            <div className="border-b border-border">
              <nav className="flex space-x-8 overflow-x-auto">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap micro-animation ${
                      activeTab === tab.id
                        ? 'border-[#E3403B] text-[#E3403B]' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                    }`}
                  >
                    <Icon name={tab.icon} size={16} />
                    <span>{tab.label}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Tab Content */}
          <div className="space-y-6">
                  {activeTab === 'billing' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-semibold text-foreground">Billing History</h2>
                  <Button
                    variant="outline"
                    iconName="Download"
                    iconPosition="left"
                    iconSize={16}
                  >
                    Export All
                  </Button>
                </div>
                <BillingHistory transactions={mockTransactions} />
              </div>
            )}
            {activeTab === 'overview' && (
              <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
                <div className="xl:col-span-2 space-y-6">
                  <QuickActions />
                  
                  {/* Recent Activity */}
                  {/* <div className="bg-card border border-border rounded-lg p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
                      <Button variant="ghost" size="sm" iconName="MoreHorizontal" iconSize={16} />
                    </div>
                    <div className="space-y-4">
                      {mockTransactions.slice(0, 5).map((transaction) => (
                        <div key={transaction.id} className="flex items-center space-x-3 p-3 rounded-md hover:bg-muted/50 micro-animation">
                          <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                            <Icon name="Receipt" size={16} className="text-primary" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-foreground truncate">
                              {transaction.employeeName} purchased {transaction.productName}
                            </p>
                            <p className="text-xs text-muted-foreground">
                              {new Date(transaction.date).toLocaleDateString()} • ${transaction.amount.toFixed(2)}
                            </p>
                          </div>
                          <div className={`w-2 h-2 rounded-full ${
                            transaction.status === 'completed' ? 'bg-success' :
                            transaction.status === 'pending' ? 'bg-warning' : 'bg-error'
                          }`} />
                        </div>
                      ))}
                    </div>
                  </div> */}
                </div>
                
                {/* Sidebar Stats */}
                <div className="space-y-6">
                  {/* <div className="bg-card border border-border rounded-lg p-6">
                    <h3 className="text-lg font-semibold text-foreground mb-4">Top Products</h3>
                    <div className="space-y-3">
                      {mockProducts
                        .sort((a, b) => b.totalSales - a.totalSales)
                        .slice(0, 5)
                        .map((product) => (
                          <div key={product.id} className="flex items-center justify-between">
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-foreground truncate">{product.name}</p>
                              <p className="text-xs text-muted-foreground">{product.totalSales} sales</p>
                            </div>
                            <span className="text-sm font-medium text-foreground">${product.price}</span>
                          </div>
                        ))}
                    </div>
                  </div> */}
                  
                  <div className="bg-card border border-border rounded-lg p-6">
                    <h3 className="text-lg font-semibold text-foreground mb-4">Employee Performance Last Month</h3>
                    <div className="space-y-3">
                      {employee
                        ?.filter(emp => emp?.active === true)
                        .sort((a, b) => b?.LastMonthSale - a?.LastMonthSale)
                        .slice(0, 3)
                        .map((employee) => (
                          <div key={employee.id} className="flex items-center space-x-3">
                            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                              <Icon name="User" size={16} className="text-primary" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-foreground truncate">{employee.name}</p>
                              <p className="text-xs text-muted-foreground">${employee?.LastMonthSale?.toFixed(2)} billed</p>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'products' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-semibold text-foreground">Product Management</h2>
                  <Button
                    variant="default"
                    iconName="Plus"
                    iconPosition="left"
                    iconSize={16}
                    onClick={() => navigate('/product-management')}
                  >
                    Add New Product
                  </Button>
                </div>
                <ProductGrid
                  products={product}
                  onEditProduct={handleEditProduct}
                  onDeleteProduct={handleDeleteProduct}
                />
              </div>
            )}

            {activeTab === 'employees' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-semibold text-foreground">Employee Management</h2>
                  <Button
                    variant="default"
                    iconName="UserPlus"
                    iconPosition="left"
                    iconSize={16}
                    onClick={() => navigate('/employee-management')}
                  >
                    Add New Employee
                  </Button>
                </div>
                <EmployeeTable
                  employees={mockEmployees}
                  onEditEmployee={handleEditEmployee}
                  onDeleteEmployee={handleDeleteEmployee}
                />
              </div>
            )}

      
          </div>
        </div>
      </main>
    </div>
  );
};

export default VendorDashboard;